@if (currentParent?.data) {
<!--
    BANNER
    -->
@if (!!model.data?.isBanner) {
<a class="pos-relative overflow-hidden height-100"
   [class]="isBannerWithTextOverImage() ? '' : 'flex flex-column flex-column-reverse'"
   [routerLink]="model.data?.banner_url || ''"
   style="border-radius: 12px;"
   [gtmPromotionLink]="{ promotionName: model.name, promotionId: model.data?.sku, creativeSlot : 'Product listing banner', creativeName: getImage()}">
    <div [class]="isBannerWithTextOverImage() ? 'height-100' : 'overflow-hidden'">
        <shell />
        <product-alt-image [mainImage]="getImage()"
                           [style.padding-bottom]="getImageHeightStyle()"
                           class="pos-relative block fill"
                           [altImage]="getAlternativeImage()"
                           [altText]="model.imageAltText || ''"></product-alt-image>
    </div>
    <!-- banner copies -->
    <div class="col-w"
         [class]="isBannerWithTextOverImage() ?  'pos-absolute bottom-0 _banner-content height-100 left-0 right-0 p-l p-r' : 'pos-relative flex-grow p-t p-l p-r p-b-8 p-b-5-s p-b-5-m  bg-col-1'"
         [ngStyle]="isBannerWithTextOverImage() ? {} : {'minHeight': '172px'}">
        <p class="h2 h3-s h3-m">{{model.name}}</p>
        <p class="p1 m-t-2">{{model.data?.banner_subtitle || ''}}</p>
        @if (model.data?.banner_url) {
        <span [buttonStyle]="'text-button'"
              class="s1 m-t">{{model.data?.banner_cta || ''}}</span>
        }
    </div>
</a>
}
@else {
<!--
        REGULAR PRODUCT
        -->
<div class="pos-relative _product-hover overflow-hidden height-100">
    <!-- image -->
    <a [style.padding-bottom]="getImageHeightStyle()"
       class="pos-relative block overflow-hidden b-a _product-image"
       [routerLink]="model.data?.url || ''"
       [gtmItemLink]>
        <shell />
        <product-alt-image [mainImage]="getImage()"
                           [altImage]="getAlternativeImage()"
                           [altText]="currentParent?.imageAltText || ''"></product-alt-image>
    </a>

    <!-- wishlist -->
    <product-wishlist-toggle [productId]="currentParent?.id"
                             [item]="wishlistItem"
                             class="pos-absolute top-2 right-2"></product-wishlist-toggle>


    <div class="p-a-2 flex-column">
        <product-plp-trustpilot-reviews [product]="model" />
        <!-- name -->
        <a class="flex-grow"
           [routerLink]="currentParent?.data?.url || ''"
           [gtmItemLink]>
            <p cy-listingProductName
               class="h5 m-t-2 col-1">{{(currentParent?.data?.name || '')| truncate: truncateLength : ' ...'}}</p>

            <!-- price -->
            @if (currentParent) {
            @if (currentParent?.data?.is_cartable) {
            <product-price [product]="currentParent"
                           class="m-t-1 inline-block"></product-price>
            } @else {
            <p class="s1 s2-s s2-m m-t-1">{{'Call us for pricing' | translate}}</p>
            }
            }
        </a>

        <!--swatches-->
        @if (getSwatchesCount()) {
        <div class="m-t-3 inline-flex">
            @for (swatch of getSwatches(4); track swatch) {
            <swatch [value]="swatch"
                    [style.width.px]="[18, 18, 24, 24][client.sizeId]"
                    [attributeCode]="swatchAttribute"
                    style="padding: 2.7px"
                    class="cursor-pointer m-r-1"
                    (click)="selectSwatch(swatch)"
                    [selected]="isSwatchSelected(swatch)"></swatch>
            }
            <!-- see more swatches -->
            @if (getSwatchesCount()>4) {
            <p class="c1 flex flex-middle">+{{getSwatchesCount()}}</p>
            }
        </div>
        }
    </div>
    <!-- listing label -->
    @if (currentParent?.label) {
    <aside class="p2 inline-block pos-absolute _label col-w"
           [style.backgroundColor]="currentParent?.labelColor || null">{{ currentParent?.labelShort }}</aside>
    }
</div>
}
}